import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, TruckIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" data-id="element-125">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-126">
        <Link to="/" className="flex items-center space-x-2" data-id="element-127">
          <TruckIcon className="h-6 w-6 text-primary" data-id="element-128" />
          <span className="font-bold text-xl tracking-tight text-foreground" data-id="element-129">
            Global Universal Logistics
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-130">
          {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-primary ${isActive(link.path) ? 'text-primary' : 'text-muted-foreground'}`} data-id="element-131">
              {link.name}
            </Link>)}
          <Link to="/quote" data-id="element-132">
            <Button variant="primary" data-id="element-133">Get a Quote</Button>
          </Link>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 text-foreground" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-134">
          {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-135" /> : <MenuIcon className="h-6 w-6" data-id="element-136" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <div className="md:hidden border-t bg-background" data-id="element-137">
          <nav className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-138">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium p-2 rounded-md ${isActive(link.path) ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-139">
                {link.name}
              </Link>)}
            <Link to="/quote" onClick={() => setIsMobileMenuOpen(false)} data-id="element-140">
              <Button variant="primary" className="w-full" data-id="element-141">
                Get a Quote
              </Button>
            </Link>
          </nav>
        </div>}
    </header>;
}